module.exports = __webpack_public_path__ + "img/bcn.a0c818de.svg";